module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/ev-6ee821600c80581c5ea46a8721add7b5.png";